/* DVWebNodeUtils: memberships types */
import { SettingsContent, SettingsContentTypes } from './settings';
import { RequestContext } from '../../types/request-context';
import * as WpsRuntime from 'DVWebNodeWpsRuntime';

export enum MembershipsElementType {
    TEXT = 'atv.wps#MembershipsText',
    TABLE = 'atv.wps#MembershipsTable'
}
export enum MembershipsActionType {
    URL = 'atv.wps#MembershipsActionURL',
    CONFIRMDIALOG = 'atv.wps#MembershipsActionConfirmDialog',
    SERVICECALL = 'atv.wps#MembershipsActionServiceCall'
}

export interface MembershipsAction {
    __type: MembershipsActionType;
    params?: { [key: string]: string };
    url?: string;
}

export interface MembershipsActionServiceCall extends MembershipsAction {
    __type: MembershipsActionType.SERVICECALL;
    csrf: string
}

export interface MembershipsActionURL extends MembershipsAction {
    __type: MembershipsActionType.URL;
    url: string;
}

export interface MembershipsActionConfirmDialog extends MembershipsAction {
    __type: MembershipsActionType.CONFIRMDIALOG;
    title: MembershipsText;
    body: MembershipsText;
    confirmText: MembershipsText;
    cancelText: MembershipsText;
}

export interface MembershipsText extends MembershipsElement {
    __type: MembershipsElementType.TEXT;
    text: string;
}

export interface MembershipsTableElement {
    columnSpan: number;
    value: MembershipsElement;
}
export interface MembershipsTable extends MembershipsElement {
    __type?: MembershipsElementType.TABLE;
    headers?: Array<MembershipsTableElement>;
    rows?: Array<Array<MembershipsTableElement>>;
    message?: String;
}

export interface MembershipsElement {
    __type?: MembershipsElementType;
    actions?: { [key: string]: MembershipsAction };
}

export interface MembershipsTemplateContent {
    title: MembershipsText;
    body?: MembershipsText;
    paymentMethodTitle?: MembershipsText;
    paymentMethodBody?: MembershipsText;
    message?: MembershipsText;
    table?: MembershipsTable | MembershipsText;
}

export interface MembershipsTemplate {
    content: MembershipsTemplateContent;
    message?: string;
}

export interface MembershipsOutput extends SettingsContent {
    __type: SettingsContentTypes.GetMembershipsOutput;
    templates?: { [key: string]: MembershipsTemplate };
    message?: string;
}

// The WPS generated RequestContext uses boolean type for 'isInternal' property, whereas
// The DVWebNodeUtils package uses PerlBool. This type override has been added here to ensure
// RequestContext in input matches the one expected by DVWebNodeUtils
export type SetSubscriptionNextRenewalInput = Omit<WpsRuntime.atv.wps.SetSubscriptionNextRenewalInput, 'context'> & {
  context: RequestContext,
  allowsRecognized?: boolean
}
